import setupComponent from './setup.component';
import SetupCreate from './create'
import SetupEdit from './edit'
import SetupAll from './all'

import PrefixTableComponent from './common/prefix-table/prefix-table.component'

let setupModule = angular.module('route', [
    SetupCreate,
    SetupEdit,
    SetupAll
  ])

  .component('setup', setupComponent)
  .component('prefixTable', PrefixTableComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('setup.edit', {
        url: '/edit/:id',
        component: 'setupedit',
        data: {
          requireACL: 'tnt_control_branch_setup.edit'
        }
      })

      .state('setup.create', {
        url: '/create',
        component: 'setupcreate',
        data: {
          requireACL: 'tnt_control_branch_setup.create'
        }
      })

      .state('setup.all', {
        url: '/all/:page',
        component: 'setupall',
        data: {
          // requireACL: 'tnt_control_branch_setup.view'
        }
      })
  })

  .name;

export default setupModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/index.js